import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadingWrapper from "./loading-wrapper";

export const withChartData = (WrappedComponent, apiCall, query) => {
  return class ChartDataHOC extends Component {
    static propTypes = {
      title: PropTypes.string,
      subtitle: PropTypes.string,
      dataFormatter: PropTypes.func,
      onDataReady: PropTypes.func
    };

    static defaultProps = {
      dataFormatter: d => d,
      onDataReady: d => d
    };

    state = {
      data: undefined,
      loading: true,
      error: false
    };

    componentDidMount() {
      this._isMounted = true;
      const { dataFormatter, onDataReady } = this.props;
      apiCall(query)
        .then(json => {
          if (this._isMounted) {
            const data = dataFormatter(json);
            this.setState(
              {
                data,
                loading: false
              },
              () => onDataReady(data)
            );
          }
        })
        .catch(() => {
          if (this._isMounted)
            this.setState(
              {
                data: undefined,
                loading: false,
                error: true
              },
              () => onDataReady(undefined)
            );
        });
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    render() {
      const { title, subtitle, style, ...rest } = this.props;
      const { data, loading, error } = this.state;
      const loadingContainerStyle = {
        ...style,
        textAlign: "center",
        minHeight: "200px"
      };
      return (
        <LoadingWrapper loading={loading} error={error} style={loadingContainerStyle}>
          {title ? <h3>{title}</h3> : null}
          {subtitle ? <small>{subtitle}</small> : null}
          {data ? <WrappedComponent {...rest} data={data} /> : null}
        </LoadingWrapper>
      );
    }
  };
};
